module.exports = __webpack_public_path__ + "img/code.23d67a98.png";